var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('base-nav-links',{attrs:{"home":"","no-back":""}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer-block"},[_c('h1',{staticClass:"ada-focus",attrs:{"role":"alert","aria-live":"assertive","tabindex":"0"}},[_vm._v("That worked!")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\tTerrific! Have a great term\n\t\t")])])
}]

export { render, staticRenderFns }